import { toValue, type MaybeRefOrGetter } from "vue";
import { useQuery } from "@pinia/colada";
import { getCalendarFunctions, getDashboard } from "@a/dashboard";

export interface CalendarRange {
    from: string;
    to: string;
}

export const dashboardKeys = {
    root: () => ["dashboard"],
    summary: () => [...dashboardKeys.root(), "summary"],
    calendar: (from: string, to: string) => [...dashboardKeys.root(), "calendar", from, to],
};

export function useDashboardQuery() {
    return useQuery({
        key: dashboardKeys.summary(),
        query: () => getDashboard(),
    });
}

export function useCalendarQuery(range: MaybeRefOrGetter<CalendarRange>) {
    return useQuery({
        key: () => {
            const { from, to } = toValue(range);
            return dashboardKeys.calendar(from, to);
        },
        query: () => {
            const { from, to } = toValue(range);
            return getCalendarFunctions(from, to);
        },
    });
}
